import { isValid, parse } from "date-fns";

import { FieldError } from "../../error";
import { Field } from "../../field";
import { BusinessOwner } from "../../fieldsets";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { determineOwnerApplicable } from "../address/utils";

export class DobField extends Field<string> {
  constructor(
    model: Merchant,
    owner: BusinessOwner,
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "03-02-2021",
      propertyName: "dob",
      uiFieldType: "Input",
      uiInputBaseProps: {
        autoComplete: "bday",
      },
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return determineOwnerApplicable(registeredCountry);
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    const valueToValidate = "" + this.value;

    let dateParsed: Date;

    if (
      registeredCountry === "United States" ||
      registeredCountry === "Canada"
    ) {
      dateParsed = parse(valueToValidate, "MM-dd-yyyy", new Date());
    } else {
      dateParsed = parse(valueToValidate, "dd-MM-yyyy", new Date());
    }

    if (!isValid(dateParsed)) {
      throw new FieldError(this, "Invalid Date", "InvalidDate");
    }

    if (dateParsed < new Date(1900, 1, 1) || dateParsed > new Date()) {
      throw new FieldError(this, "Invalid Date", "InvalidDate");
    }
  }
}
